import { FormControl } from "@angular/forms";

export class JsonValidator {
  static isJsonRequired(control: FormControl): any {
    const obj = Object.keys(control.value);
    if (obj.length === 0) {
      return { invalid: true };
    } else {
      return null;
    }
  }

  static isJsonFiveLength(control: FormControl): any {
    const obj = Object.keys(control.value);
    if (obj.length < 5) {
      return { invalid: true };
    } else {
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/validators/json.ts